export const homeContent = {
    es: {
        badge: 'IPTV Premium · Activación en minutos',
        titleLine1: 'Todo tu entretenimiento,',
        titleLine2: 'reunido ',
        titleGradient: 'en una sola pantalla.',
        subtitle: 'Disfruta de la televisión en directo, el deporte, las películas y las series en un mismo lugar, con una experiencia rápida, estable y compatible con todos tus dispositivos.',
        ctaOffers: 'Ver las ofertas',
        ctaSport: 'Ver el deporte',
        activationBadge: 'Activación inmediata',
        qualityBadge: '4K · 8K ULTRA HD',
        liveNow: 'En directo ahora',
        liveChannels: '+79.000 canales activos',
    },
};
